// extracted by mini-css-extract-plugin
module.exports = {"banner":"VideoErrorBanner_banner__f0eJg","msg":"VideoErrorBanner_msg__6h2Un","title":"VideoErrorBanner_title__1x2vf","subtitle":"VideoErrorBanner_subtitle__c7l12"};